/**
 * Intake input masks — PURE formatting helpers (L1A redesign, 2026-06-21).
 *
 * Kept in a `.ts` (no JSX) file so the Node `.cjs` test runner can pin them via
 * `_tsload`. The React wrappers (DateMask / TimeMask in `components/IntakeInputs`)
 * are thin shells over these.
 */

/**
 * PURE — format a raw string as `DD / MM / YYYY`. Strips non-digits, caps at 8
 * digits, inserts the ` / ` separators progressively. Idempotent on an already
 * formatted value (re-running on "21 / 09 / 1985" yields the same).
 */
export function maskDate(raw: string): string {
  const d = (raw || '').replace(/\D/g, '').slice(0, 8);
  let o = d.slice(0, 2);
  if (d.length > 2) o += ' / ' + d.slice(2, 4);
  if (d.length > 4) o += ' / ' + d.slice(4, 8);
  return o;
}

/**
 * PURE — format a raw string as `HH : MM` (24-hr, exact minute). Strips
 * non-digits, caps at 4 digits, inserts the ` : ` separator after HH.
 */
export function maskTime(raw: string): string {
  const d = (raw || '').replace(/\D/g, '').slice(0, 4);
  let o = d.slice(0, 2);
  if (d.length > 2) o += ' : ' + d.slice(2, 4);
  return o;
}
